export const productDetailsFragment = `
  fragment productDetailsFields on CpscItem {
    itemIdentifiers {
      type
      number
    }
    productCodes {
      type
      code
    }
    tradeName
    productName
    manufactureDate
    characteristics {
      type
      description
    }
  }
`;
